// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app {
  height: 100%;
}

html,
body {
  position: relative;
  height: 100%;
}

body {
  background: #000;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #fff;
  margin: 0;
  padding: 0;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #444;
  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.slide-content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  text-align: var(--slider-content-align-desktop);
  padding: var(--slider-content-padding-desktop);
}
@media (max-width: 767px) {
  .slide-content {
    text-align: var(--slider-content-align-mobile);
    padding: var(--slider-content-padding-mobile);
  }
}
.slide-content__video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}
.slide-content__title, .slide-content__subtitle {
  position: relative;
  z-index: 1;
}
.slide-content__title {
  color: var(--hero-title-color) !important;
  font-size: var(--slider-content-title-size-desktop);
}
@media (max-width: 767px) {
  .slide-content__title {
    font-size: var(--slider-content-title-size-mobile);
  }
}
.slide-content__subtitle {
  color: var(--hero-subtitle-color) !important;
  font-size: var(--slider-content-subtitle-size-desktop);
}
@media (max-width: 767px) {
  .slide-content__subtitle {
    font-size: var(--slider-content-subtitle-size-mobile);
  }
}
.slide-content__cta-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}
.slide-content__cta-btn {
  margin-top: 2rem;
  width: fit-content !important;
  align-self: var(--slider-cta-btn-align-desktop, center);
  padding-left: 4rem !important;
  padding-right: 4rem !important;
  background-color: var(--slider-content-cta-bg-color) !important;
  color: var(--slider-content-cta-text-color) !important;
  border-color: var(--slider-content-cta-border-color) !important;
}
.slide-content__cta-btn:hover {
  background-color: var(--slider-content-cta-hover-bg-color) !important;
  color: var(--slider-content-cta-hover-text-color) !important;
  border-color: var(--slider-content-cta-hover-border-color) !important;
}
@media (max-width: 767px) {
  .slide-content__cta-btn {
    align-self: var(--slider-cta-btn-align-mobile, var(--slider-cta-btn-align-desktop, center));
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
}
.slide-content__extra {
  z-index: 1;
}
.slide-content__extra--vod {
  margin-top: 0 !important;
}
.slide-content__extra h4 {
  color: var(--slider-extra-contents-color);
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Slider/Slider.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AACA;;EAEI,kBAAA;EACA,YAAA;AAEJ;;AACA;EACI,gBAAA;EACA,yDAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAEJ;;AACA;EACI,WAAA;EACA,YAAA;AAEJ;;AACA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EAEA,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAGI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kCAAA;EACA,4BAAA;EACA,sBAAA;EACA,gBAAA;EACA,+CAAA;EACA,8CAAA;AAAR;AAEQ;EAdJ;IAeQ,8CAAA;IACA,6CAAA;EACV;AACF;AACQ;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;AACZ;AAEQ;EAEI,kBAAA;EACA,UAAA;AADZ;AAIQ;EACI,yCAAA;EACA,mDAAA;AAFZ;AAIY;EAJJ;IAKQ,kDAAA;EADd;AACF;AAIQ;EACI,4CAAA;EACA,sDAAA;AAFZ;AAIY;EAJJ;IAKQ,qDAAA;EADd;AACF;AAIQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAFZ;AAKQ;EACI,gBAAA;EACA,6BAAA;EACA,uDAAA;EACA,6BAAA;EACA,8BAAA;EAEA,+DAAA;EACA,sDAAA;EACA,+DAAA;AAJZ;AAMY;EACI,qEAAA;EACA,4DAAA;EACA,qEAAA;AAJhB;AAOY;EAjBJ;IAkBQ,2FAAA;IACA,6BAAA;IACA,8BAAA;EAJd;AACF;AAOQ;EACI,UAAA;AALZ;AAOY;EACI,wBAAA;AALhB;AAQY;EACI,yCAAA;AANhB","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
